var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalorie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 62,
    viewBox: "0 0 44 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .bg {\n            fill: #767676;\n        }\n\n        .fg {\n            fill: #FFFFFF;\n        }\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M32.2,18C18.8,8.9,24.9,0,24.9,0C11.8,7.7,9,19.5,12.2,34.4c-4.7-3.9-5.4-8.5-5.2-14.7 c-6,6.6-7.1,13.5-6.7,21.1C0.5,46.5,3,51.9,7,55.9S16.5,62,22.1,62c5.6,0,11-2.3,15-6.3s6.4-9.4,6.6-15.2 C44.2,30.7,40.2,23.4,32.2,18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fg",
    d: "M23.5,56.8c-3,0-5.9-0.9-8.4-2.6c0.6,0.1,1.2,0.1,1.8,0.1c5.1,0,10.1-2.1,13.7-5.9c3.6-3.7,5.7-8.8,5.7-14.1 c0-0.6,0-1.2-0.1-1.8c1.7,2.5,2.6,5.5,2.6,8.6c0,2.1-0.4,4.1-1.2,6c-0.8,1.9-1.9,3.6-3.3,5.1s-3.1,2.6-4.9,3.4 C27.4,56.4,25.4,56.8,23.5,56.8L23.5,56.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalorie);
export default __webpack_public_path__ + "static/media/calorie.aea43e2f915dc3aeb532ba8947f8159e.svg";
export { ForwardRef as ReactComponent };